import React, { useState, useRef, useEffect, useCallback } from "react";
import ListPageHeader from "../../utilities/ListPageHeader";
import {
  Box,
  Button,
  Divider,
  Grid,
  Paper,
  Step,
  StepLabel,
  Stepper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Typography,
} from "@mui/material";
import FusePageCarded from "@fuse/core/FusePageCarded/FusePageCarded";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import {
  TabPanel,
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
  timelineItemClasses,
} from "@mui/lab";
import { grey } from "@mui/material/colors";

const DownloadPDF = (props) => {
  const theme = useTheme();

  return (
    <svg
      width={69}
      height={71}
      viewBox="0 0 69 71"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M40.1259 2.64001H9.24001V63.36H56.76V19.2741L40.1259 2.64001ZM39.6 19.8V5.80595L53.5941 19.8H39.6Z"
        fill={theme.palette.secondary.main}
      />
      <path
        d="M22.6953 40V32H25.8516C26.4583 32 26.9753 32.1159 27.4023 32.3477C27.8294 32.5768 28.1549 32.8958 28.3789 33.3047C28.6055 33.7109 28.7188 34.1797 28.7188 34.7109C28.7188 35.2422 28.6042 35.7109 28.375 36.1172C28.1458 36.5234 27.8138 36.8398 27.3789 37.0664C26.9466 37.293 26.4232 37.4062 25.8086 37.4062H23.7969V36.0508H25.5352C25.8607 36.0508 26.1289 35.9948 26.3398 35.8828C26.5534 35.7682 26.7122 35.6107 26.8164 35.4102C26.9232 35.207 26.9766 34.974 26.9766 34.7109C26.9766 34.4453 26.9232 34.2135 26.8164 34.0156C26.7122 33.8151 26.5534 33.6602 26.3398 33.5508C26.1263 33.4388 25.8555 33.3828 25.5273 33.3828H24.3867V40H22.6953ZM32.6533 40H29.8174V32H32.6768C33.4814 32 34.1742 32.1602 34.7549 32.4805C35.3356 32.7982 35.7822 33.2552 36.0947 33.8516C36.4098 34.4479 36.5674 35.1615 36.5674 35.9922C36.5674 36.8255 36.4098 37.5417 36.0947 38.1406C35.7822 38.7396 35.333 39.1992 34.7471 39.5195C34.1637 39.8398 33.4658 40 32.6533 40ZM31.5088 38.5508H32.583C33.083 38.5508 33.5036 38.4622 33.8447 38.2852C34.1885 38.1055 34.4463 37.8281 34.6182 37.4531C34.7926 37.0755 34.8799 36.5885 34.8799 35.9922C34.8799 35.401 34.7926 34.918 34.6182 34.543C34.4463 34.168 34.1898 33.8919 33.8486 33.7148C33.5075 33.5378 33.0869 33.4492 32.5869 33.4492H31.5088V38.5508ZM37.8203 40V32H43.1172V33.3945H39.5117V35.3008H42.7656V36.6953H39.5117V40H37.8203Z"
        fill="white"
      />
      <circle cx={56} cy={58} r={13}
        fill={theme.palette.warning.main} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.3333 56V54.6667H60C61.1046 54.6667 62 55.5621 62 56.6667V62C62 63.1046 61.1046 64 60 64H52C50.8954 64 50 63.1046 50 62V56.6667C50 55.5621 50.8954 54.6667 52 54.6667H52.6667V56H52C51.6318 56 51.3333 56.2985 51.3333 56.6667V62C51.3333 62.3682 51.6318 62.6667 52 62.6667H60C60.3682 62.6667 60.6667 62.3682 60.6667 62V56.6667C60.6667 56.2985 60.3682 56 60 56H59.3333ZM56.6965 57.3649L57.4776 56.5931C57.7496 56.3243 58.1906 56.3243 58.4627 56.5931C58.7347 56.8619 58.7347 57.2977 58.4627 57.5665L56 60L53.5373 57.5665C53.2653 57.2977 53.2653 56.8619 53.5373 56.5931C53.8094 56.3243 54.2504 56.3243 54.5224 56.5931L55.3035 57.3649V52.0217C55.3035 51.6415 55.6153 51.3334 56 51.3334C56.3847 51.3334 56.6965 51.6415 56.6965 52.0217V57.3649Z"
        fill="white"
      />
    </svg>
  );
};


const useStyles = makeStyles((theme) => ({
  root: {
    "& .order-detail-summary": {
      "& li": {
        padding: "5px 0px",

        "& label": {
          display: "inline-block",
          width: "50%",
        },
      },
    },
  },
}));

const steps = [
  "New",
  "Assigned",
  "In Progress",
  "Waiting AB",
  "ACK FRM FACTORY",
  "AB Received",
  "Under Confirmation",
  "Confirmed",
  "Ready to Book",
  "Production Planning",
  'PI Generated',
  'Ready to Release',
  'Released',
  'Loaded',
  'Invoiced'
];

const rows = [
  {
    id: 1,
    range: "Range",
    color: "Color",
    carCass: "CarCass",
    handle: "Handle",
  },
  {
    id: 2,
    range: "Range1",
    color: "Color23",
    carCass: "CarCass3",
    handle: "Handle4",
  },
];

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ViewOrder = (props) => {
  const theme = useTheme();
  const classes = useStyles(props);
  const [showPaginationDropdown, setShowPaginationDropdown] = useState(false);
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <>
      <FusePageCarded
        classes={{
          content: "flex",
          header: "min-h-72 h-72 sm:h-136 sm:min-h-136",
        }}
        header={
          <ListPageHeader
            componentName="View Order"
            pageName="View Order"
            showPaginationDropdown={showPaginationDropdown}
          />
        }
        content={
          <div className={clsx(classes.root)}>
            <Box sx={{ width: "100%", my: 2 }}>
              <Stepper
                activeStep={1}
                alternativeLabel
                sx={{
                  "& .MuiStepIcon-root.Mui-active": {
                    color: theme.palette.secondary.main,
                  },
                  "& .MuiStepIcon-root.Mui-completed": {
                    color: theme.palette.secondary.main,
                  },
                }}
              >
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Box>
            <Box className="px-24 md:px-32">
              <Grid container xs={12} spacing={3}>
                <Grid item sm={6}>
                  <Box
                    className="rounded-2xl"
                    sx={{ border: `1px solid ${theme.palette.divider}`, p: 3 }}
                  >
                    <ul className="order-detail-summary">
                      <li>
                        <label>Customer</label>BEDQUARTER COMPANY
                      </li>
                      <li>
                        <label>Showroom</label>BQ-RIYADHI
                      </li>
                      <li>
                        <label>Product</label>Nolte Kuechen
                      </li>
                      <li>
                        <label>Order Category</label>Retail
                      </li>
                      <li>
                        <label>Processed On</label>PLACED
                      </li>
                      <li>
                        <label>Order Reference</label>BQ554901
                      </li>
                    </ul>
                    <Divider sx={{ my: 3 }} />
                    <ul className="order-detail-summary">
                      <li>
                        <label>Type Number</label>1
                      </li>
                      <li>
                        <label>Unique ID</label>BQ
                      </li>
                      <li>
                        <label>Client Name</label>BEDQUARTER
                      </li>
                      <li>
                        <label>Commission Name</label>Commission Name
                      </li>
                      <li>
                        <label>WGI List Price (Euros)</label>€10
                      </li>
                      <li>
                        <label>WG2 List Price (Euros)</label>€120
                      </li>
                      <li>
                        <label>Total List Price (Euros)</label>€130
                      </li>
                      <li>
                        <label>Volume(cbm)</label>15
                      </li>
                      <li>
                        <label>Weight (kg)</label>584
                      </li>
                      <li>
                        <label>Container No</label>458
                      </li>
                      <li>
                        <label>Loading Week</label>2
                      </li>
                      <li>
                        <label>Freight</label>8
                      </li>
                      <li>
                        <label>Special Comments</label>sdfsdfsdfsdfsd
                      </li>
                    </ul>
                  </Box>
                </Grid>
                <Grid item sm={6}>
                  <Box>
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Range</TableCell>
                            <TableCell>Color</TableCell>
                            <TableCell>Carcass</TableCell>
                            <TableCell>Handle</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows.map((row) => (
                            <TableRow
                              key={row.name}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell>{row.range}</TableCell>
                              <TableCell>{row.color}</TableCell>
                              <TableCell>{row.carCass}</TableCell>
                              <TableCell>{row.handle}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                  <Box
                    className="rounded-2xl"
                    sx={{ width: "100%", border: `1px solid ${theme.palette.divider}`, my: 4 }}
                  >
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        textColor="inherit"
                        indicatorColor="secondary"
                        variant="scrollable"
                        classes={{ root: "w-full border-b-1" }}
                      >
                        <Tab
                          label="DRW File"
                          sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }}
                        />
                        <Tab
                          label="Appliances Detail"
                          sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }}
                        />
                        <Tab
                          label="Order Checklist"
                          sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }}
                        />
                        <Tab
                          label="Drawing File"
                          sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }}
                        />
                      </Tabs>
                    </Box>
                    <div className={tabValue !== 0 ? "hidden" : "h-full"}>
                      <Box className="flex justify-center" sx={{ p: 3, minHeight: 100, }}>
                        <Button variant="text">
                          <DownloadPDF />
                        </Button>
                      </Box>
                    </div>
                    <div className={tabValue !== 1 ? "hidden" : "h-full"}>
                      <Box sx={{ p: 3, minHeight: 100 }}>Appliances Detail</Box>
                    </div>
                    <div className={tabValue !== 2 ? "hidden" : "h-full"}>
                      <Box sx={{ p: 3, minHeight: 100 }}>Order Checklist</Box>
                    </div>
                    <div className={tabValue !== 3 ? "hidden" : "h-full"}>
                      <Box sx={{ p: 3, minHeight: 100 }}>Drawing File</Box>
                    </div>
                  </Box>
                  <Box
                    className="rounded-2xl"
                    sx={{ border: "1px solid #757575" }}
                  >
                    <Typography
                      variant="subtitle1"
                      gutterBottom
                      sx={{
                        py: 1,
                        px: 2,
                        background: grey[700],
                        borderTopLeftRadius: 16,
                        borderTopRightRadius: 16,
                      }}
                    >
                      Order History
                    </Typography>
                    <Timeline
                      sx={{
                        [`& .${timelineItemClasses.root}:before`]: {
                          flex: 0,
                          padding: 0,
                        },
                      }}
                    >
                      <TimelineItem>
                        <TimelineSeparator>
                          <TimelineDot />
                          <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent>
                          Order #BQ554901 Placed
                        </TimelineContent>
                      </TimelineItem>
                      <TimelineItem>
                        <TimelineSeparator>
                          <TimelineDot />
                          <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent>
                          Order #BQ554901 Placed
                        </TimelineContent>
                      </TimelineItem>
                      <TimelineItem>
                        <TimelineSeparator>
                          <TimelineDot />
                        </TimelineSeparator>
                        <TimelineContent>
                          Order #BQ554901 Placed
                        </TimelineContent>
                      </TimelineItem>
                    </Timeline>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </div>
        }
        innerScroll
      />
    </>
  );
};

export default ViewOrder;
